import { SuperAdminService } from "services/superAdminService";

class DuasCategoriesSAService extends SuperAdminService<any> {
  constructor() {
    super("dua-categories");
  }
}
export default new DuasCategoriesSAService();
